import { z } from 'zod';
import { paginationQuerySchema } from '../pagination.js';
import { optionalString } from './common.js';
import { PERMISSIONS } from '../permissions.js';
/** Clé de permission valide (contrôlée contre le catalogue). */
const permissionKey = z.enum([...PERMISSIONS]);
const passwordField = z.string().min(8, 'Au moins 8 caractères').max(128);
// --- Utilisateurs ---------------------------------------------------------
export const createUserSchema = z.object({
    email: z.string().trim().email('Email invalide').max(180),
    firstName: z.string().trim().min(1, 'Prénom requis').max(100),
    lastName: z.string().trim().min(1, 'Nom requis').max(100),
    phone: optionalString(30),
    roleId: z.string().trim().min(1, 'Rôle requis'),
    password: passwordField,
    isActive: z.boolean().default(true),
});
export const updateUserSchema = z.object({
    email: z.string().trim().email('Email invalide').max(180).optional(),
    firstName: z.string().trim().min(1, 'Prénom requis').max(100).optional(),
    lastName: z.string().trim().min(1, 'Nom requis').max(100).optional(),
    phone: optionalString(30),
    roleId: z.string().trim().min(1).optional(),
    isActive: z.boolean().optional(),
});
export const resetPasswordSchema = z.object({ password: passwordField });
export const usersQuerySchema = paginationQuerySchema.extend({
    active: z
        .union([z.boolean(), z.enum(['true', 'false'])])
        .optional()
        .transform((v) => (v === undefined ? undefined : v === true || v === 'true')),
    roleId: z.string().trim().optional(),
});
// --- Rôles ----------------------------------------------------------------
export const createRoleSchema = z.object({
    label: z.string().trim().min(1, 'Nom du rôle requis').max(80),
    description: optionalString(255),
    permissions: z.array(permissionKey).default([]),
});
export const updateRoleSchema = z.object({
    label: z.string().trim().min(1, 'Nom du rôle requis').max(80).optional(),
    description: optionalString(255),
    permissions: z.array(permissionKey).optional(),
});
//# sourceMappingURL=user.js.map